import { render, staticRenderFns } from "./PreRegisterForm.vue?vue&type=template&id=73dc1412"
import script from "./PreRegisterForm.vue?vue&type=script&lang=js"
export * from "./PreRegisterForm.vue?vue&type=script&lang=js"
import style0 from "./PreRegisterForm.vue?vue&type=style&index=0&id=73dc1412&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports